declare global {
    interface Window {
        context: string;
    }
}

export function url(uri: string) {
    const context = window.context;

    if (uri.startsWith("/")) {
        uri = uri.substring(1)
    }

    return context + uri;
}
